<template>
  <v-container>
    <v-card class="pa-8 mx-auto" max-width="900">
      <!-- タイトル -->
      <v-row class="mb-8">
        <v-col class="text-center">
          <h2 class="text-h4 font-weight-bold">
            【登録完了】
          </h2>
        </v-col>
      </v-row>

      <!-- メッセージ（新規申込用） -->
      <v-row v-if="!isSubscribed" class="mb-8">
        <v-col>
          <p class="text-body-1 mb-6">
            この度は、JWNET加入兼JWNET連携サービスのお申し込みをいただき誠にありがとうございます。
          </p>
          <p class="text-body-1">
            JWNETログイン情報は別途「公益財団法人 日本産業廃棄物処理振興センター」からメールが3営業日以内に送信されますので、受信したJWNETログイン情報の保持をお願いいたします。
          </p>
        </v-col>
      </v-row>

      <!-- メッセージ（既存申込用） -->
      <v-row v-if="isSubscribed" class="mb-8">
        <v-col>
          <p class="text-body-1 mb-6">
            この度は、JWNET-EDI連携サービスのお申込みをいただき誠にありがとうございます。
          </p>
          <p class="text-body-1 mb-4">
            JWNETより「EDI方式利用申込完了のお知らせ」メールが3営業日以内に送信されます。
          </p>
          <p class="text-body-1">
            なお、本メールは複数回届く場合がございますが、加入者様側での操作は不要です。
          </p>
        </v-col>
      </v-row>

      <!-- 収集運搬事業者（新規申込の場合のみ表示） -->
      <v-row v-if="!isSubscribed && transport_name" class="mb-8">
        <v-col>
          <p class="text-body-1">
            {{ transport_name }}
          </p>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'EdiRequestRegistrationCompleted',
  props: {
    transportName: {
      type: String,
      default: ''
    },
    isSubscribed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      transport_name: this.transportName
    }
  },
  methods: {
    closeWindow() {
      this.$router.push({ name: 'EdiRequestIndex' })
     
    }
  }
}
</script>

<style scoped>
.text-none {
  text-transform: none !important;
}
</style>
